module.exports = __webpack_public_path__ + "static/media/ciniphilia_react.7e08830b.PNG";